import { awaitJSON, DigitalAuditLambdaFetch } from '@src/utils/fetch-utils';
import { EvidenceBlob, PageMetric, DiscoverabilityInfo } from './engine/martech-scanner-constants';

export interface ScanArtifacts {
  finalUrl: string;
  domain: string;
  evidenceBlobs: EvidenceBlob[];
  scriptSrcs: string[];
  headers: Record<string, string>;
  // Every page the backend crawl actually fetched (seed + discovered key
  // pages), final URLs after redirects. Always contains at least finalUrl.
  pagesScanned: string[];
  // Per-page load metrics (server response / download / size); optional until
  // the backend crawl that produces them is deployed.
  pageMetrics?: PageMetric[];
  // robots/sitemap/llms.txt facts; optional for the same reason.
  discoverability?: DiscoverabilityInfo;
  errors: string[];
}

// Thin proxy — the backend only fetches the SSRF-guarded HTML/JS artifacts;
// signature matching happens client-side (engine/martech-scanner-utils.ts).
export const fetchScanArtifacts = async (url: string): Promise<ScanArtifacts> => {
  const res = await DigitalAuditLambdaFetch('/digital-audit/scan', {
    method: 'POST',
    body: { url }
  });
  return awaitJSON<ScanArtifacts>(res);
};
